/* eslint-disable react/prop-types */
import { Typography } from '@mui/joy';
import JoyAlert from '@mui/joy/Alert';
import clsx from 'clsx';
import * as React from 'react';

export const Alert = JoyAlert;

export const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<typeof Typography>
>(({ ...props }, ref) => (
  <Typography ref={ref} fontWeight={600} {...props} level='inherit' />
));
AlertTitle.displayName = 'AlertTitle';

export const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<typeof Typography>
>(function AlertDescription({ className, ...props }, ref) {
  return (
    <Typography
      ref={ref}
      sx={{ color: 'inherit', fontSize: 'inherit' }}
      {...props}
      level='body-sm'
    />
  );
});

export const AlertFooter = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'div'>
>(function AlertFooter({ className, ...props }, ref) {
  return <div ref={ref} className={clsx('pt-4', className)} {...props} />;
});
